// extracted by mini-css-extract-plugin
module.exports = {"body":"ActivityPage_body__1U7kL"};